<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Dados do Parceiro</mat-panel-title>
            </mat-expansion-panel-header>

            <mat-tab-group>
                
                <!-- PARCEIRO -->
                <mat-tab label="Parceiro"> 
                    <dados-parceiro [parceriasProjeto]=parceriasProjeto></dados-parceiro>     
                </mat-tab>
                
                <!-- CENTROS DE CUSTO -->
                <mat-tab label="Centros de Custos"> 
                    <contas-centros-custo [listaContasCentrosCusto]=parceriasProjeto.contasCentrosCusto></contas-centros-custo>    
                </mat-tab>

                <!-- MATERIAIS -->
                <mat-tab label="Materiais"> 
                    <materiais-projeto [listaMateriaisProjeto]=parceriasProjeto.materiaisProjeto></materiais-projeto>
                </mat-tab>

                <!-- CATEGORIAS -->
                <mat-tab label="Categorias"> 
                    <parcerias-categorias [listaParceriasCategorias]=parceriasProjeto.parceriasCategorias></parcerias-categorias>
                </mat-tab>
            </mat-tab-group>

            <span *ngIf="isSomaDasCategoriasDiferenteDaSomaDosParceiros()"  style="color: orangered; padding-left: 10px;"><b>ATENÇÃO:</b> A soma das categorias e seus aditivos é diferente da soma do parceiro e seus aditivos.</span>
            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button *ngIf="!isAtualizar"  mat-raised-button name="botaoAdicionar" [disabled]="formulario.invalid || isSomaDasCategoriasDiferenteDaSomaDosParceiros()" fxFlex="20%"
                    color="primary" (click)="adicionar()">
                    Adicionar
                </button>
              
                <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]="formulario.invalid || isSomaDasCategoriasDiferenteDaSomaDosParceiros()" fxFlex="20%"
                    color="primary" (click)="atualizar()">
                    Atualizar
                </button>

            </div>

        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
            (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Lista de Parceiros ( {{listaParceiros?.length}} )
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                style="margin-top: 20px">

                <ng-container matColumnDef="codigo">
                    <th mat-header-cell *matHeaderCellDef> Código </th>
                    <td mat-cell *matCellDef="let element"> {{element.empresa.codigo}} </td>
                </ng-container>

                <ng-container matColumnDef="nomeRazaoSocial">
                    <th mat-header-cell *matHeaderCellDef> Razão social </th>
                    <td mat-cell *matCellDef="let element"> {{element.empresa.nomeRazaoSocial}} </td>
                </ng-container>

                <ng-container matColumnDef="cnpj">
                    <th mat-header-cell *matHeaderCellDef> CNPJ</th>
                    <td mat-cell *matCellDef="let element"> {{element.empresa.cnpj | cnpj}} </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element">
                        <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizarComposicao(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{msg}}
                </div>
            </ng-template>

            <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
                style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar nova parceria" mat-fab color="primary" (click)="novo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion>
</form>